import React, { Component } from "react";
import Dialog from "../../../dialogs/dialog";
import DialogInput from "../../../dialogs/input";
import DialogUpload from "../../../dialogs/uploadfile";
import SimplePopup from "../../../../components/bases/popup/simplePopup";
import { apiCreateSeries,apiDeleteSeries, apiUpdateSeries } from "../../../../utils/apis";
class SerieForm extends Dialog
{
  constructor(props) 
  {
    super(props);
    this.state.title= {en:"Error !!!",  fr:"Erreur !!!",}

    this.state.msgname ="";
    this.state.msgmail="";
    this.state.formulaire ={};

    if (this.props.action != "add")
    {
        console.log("DELETE/EDIT TABLE SERIE")
        this.state.formulaire.id = this.props.formulaire.seid;
        this.state.formulaire.idbase = this.props.formulaire.seidbase;
        this.state.formulaire.name = this.props.formulaire.sename;
        this.state.formulaire.image = this.props.formulaire.seimage;

    }

    this.state.displaydeletepopup = false;


    switch (this.props.action)
    {
        case "add":
            this.state.title= {en:"Add Serie",  fr:"Ajouter une série",}
            this.state.formulaire = {id:0,idbase:"",name:"",image:""};
            break;
        case "edit":
            this.state.title= {en:"Edit Serie",  fr:"Modifier une série",}
            break;
        case "delete":
            this.state.title= {en:"Delete Serie",  fr:"Supprimer une série",}
            break;
    }

    
    


    var buttons = [];

    buttons.push({type:"back", disabled:false});

    if (this.props.action != "delete")
      buttons.push({type:"ok", disabled:false});
    else
      buttons.push({type:"text", disabled:false,text:{fr:"Supprimer",en:"Delete"},key:"ok"})

    this.state.buttons = buttons;

    this.idbaseRef = React.createRef();
    this.nameRef = React.createRef();
    this.imageRef = React.createRef();
    

    this.handleButton =  this.handleButton.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.retourapidelete = this.retourapidelete.bind(this)
    this.retourapi = this.retourapi.bind(this);
    this.popupreturn = this.popupreturn.bind(this)
    this.onQuit = this.onQuit.bind(this)
  }
  checkvalidemail(cmail)
    {
        if (cmail=="") return true;
        if (!cmail.match(/[a-z0-9_\-\.]+@[a-z0-9_\-\.]+\.[a-z]+/i)) {
            return false;
        }        
        return true;
    }

    onQuit()
    {
      this.props.onvalidform({ret:false});
    }

    onValid()
    {
      console.log("Client form on valid")
      this.handleButton("ok");
    }

    popupreturn()
    {
      this.setState({displaydeletepopup:false});

    }

    retourapidelete(ret)
    {
   

      var retour = {};
      retour.action = this.props.action;
      retour.ok = ret.ret;


      if (ret.ret )
      {
        retour.id = ret.id;
        retour.msg = ret.msg;
        this.props.onvalidform(retour);
        return;
      }


      if (ret.msg == "inuse")
      {
          this.setState({displaydeletepopup:true});
          return;
      }
      else
        this.props.onvalidform(retour);


      
    }


  retourapi(ret)
  {
 
    var retour = {};
    retour.action = this.props.action;
    retour.ok = ret.ret;
    if (ret.ret )
    {
      retour.id = ret.id;
      retour.msg = ret.msg;
    }
    this.props.onvalidform(retour);
  }


  getApiFormulaire(formulaire)
  {
    var apiformulaire = {};

    apiformulaire.seid = this.state.formulaire.id;
    apiformulaire.seidbase = formulaire.idbase;
    apiformulaire.sename = formulaire.name;
    apiformulaire.seimage = formulaire.image;


    return apiformulaire;    
  }

  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)

    switch(buttonkey)
    {
       case "ok":
          var formulaire = {};
          formulaire.id = 0;
          formulaire.idbase = this.idbaseRef.current.getValue();
          formulaire.name = this.nameRef.current.getValue();
          formulaire.image = this.imageRef.current.getValue();    

          console.log(formulaire)
          var errname="";
          if (formulaire.name == "") errname=this.context.language=="fr"?"Zone obligatoire.":"Required field.";
          this.nameRef.current.setErrorMsg(errname);

   
          
          if (errname != "") return;

          if (this.props.action == "add")
          {
            var apiformulaire = this.getApiFormulaire(formulaire);
            apiCreateSeries(apiformulaire, this.retourapi);      
          }
          
          if (this.props.action == "delete")
          {
            var apiformulaire = this.getApiFormulaire(formulaire);
            apiDeleteSeries(apiformulaire, this.retourapidelete);      
          }

          if (this.props.action == "edit")
          {
            var apiformulaire = this.getApiFormulaire(formulaire);
              apiUpdateSeries(apiformulaire, this.retourapi);      
          }
            

          break;
      case "back":
        this.onQuit();
        return;
    }

  }

  
  handleOnChange()
  {

  }

  render()
  {

    const disable = (this.props.action == "delete");
    const retour =
    (
      <>

      <SimplePopup
        display = {this.state.displaydeletepopup}
        title = {{"fr": "Suppression impossible.", "en": "Impossible to delete"}} 
        onCancel ={this.popupreturn}
        text = {
          {"fr": "Cette série est utilisée dans dans autre projet.", "en": "This serie is in use in another project"}
        }

        buttons = {           
          [ {text:{"fr":"Ok","en":"Ok"}, onclick :this.popupreturn } ]
          }
        />



      <DialogInput
                value = {this.state.formulaire.idbase}
                disabled={true}
                onChange =  {this.handleOnChange}
                autoFocus = {false}
                ref = {this.idbaseRef}
                readOnly = {true}
                width = "400px"
                title = {this.context.language=="fr"?"ID Base":"Base ID"}
              />




     
      <DialogInput
                value = {this.state.formulaire.name}
                disabled={disable}
                autoFocus = {true}
                ref = {this.nameRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                errmsg={this.state.msgname}
                title = {this.context.language=="fr"?"Nom":"Name"}
              />


      <DialogUpload
        validFiles = {["png","jpg"]}
        ref = {this.imageRef}
        width = {120}
        disabled={disable}
        mode="image"
        image={this.state.formulaire.image}
        onChange =  {this.handleOnChange}
      />

      </>

    )

    return super.render(retour);
  }


}
SerieForm.defaultProps = 
{
    selectButton: false,
    zindex:2,
    closebutton: true,
}




export default SerieForm;